import { styled } from '@linaria/react';

import { AnimatedNumberWithContent } from '~shared/ui/molecules';

import { HeaderButtonDataContainer } from '../../Header.styles';

export const CurrentNeurons = styled(HeaderButtonDataContainer)`
	gap: 2px;
	padding: 0 8px 0 12px;
	height: 32px;
`;

export const StyledAnimatedNumberWithContent = styled(
	AnimatedNumberWithContent
)`
	gap: 2px;
	display: flex;
	align-items: center;
	justify-content: space-between;
`;
